<template>
<div class="app-container1" >
  <div v-if="flag==1">
    
    <month :data="flag" @changeFlag="setFlag"></month>
    
  </div>  
  <div v-if="flag==2">
      <season :data="flag" @changeFlag="setFlag"></season>
  </div> 
  <div v-if="flag==3">
      <year :data="flag" @changeFlag="setFlag"></year>
  </div> 
</div>
</template>
<script>
  import year from './components/year';
  import season from './components/season';
  import month from './components/month';





export default {
   components: {year, season, month},
   data(){
            return{
                flag:1,
            }
   },
    methods: {
      // 设置日期范围查询条件
     setFlag(params) {
        //alert("parent=="+params);
          this.flag=params;
         
     }
   }
}
</script>
<style scoped>
.app-container1 {
  padding: 10px;
  
  background-color: rgba(243, 247, 255, 1);
  border-radius: 5px;
  min-height: calc(100vh + 500px);
  
}
</style>
